module.exports = __webpack_public_path__ + "static/media/ErrorImage.ca48ad6d.png";